import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.modules.modals,
    props.modules.modals_data,
    (modals, modals_data) => {
        const list = [];
        for(const key of modals)
            list.push({
                key,
                data: modals_data[key]
            });

        return {
            modals: list
        }
    }
)